import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const humbBtn = document.querySelector('.l-header__humb');
const humbMenu = document.querySelector('.l-header__menu');
const body = document.querySelector('html');
const navItems = document.querySelectorAll('.nav__item');

class Nav {
  openFlag = false;

  constructor() {
    this.events();
  }

  // イベント
  events() {
    humbBtn.addEventListener('click', this.onClickDispatcher.bind(this));
    navItems.forEach((navItem) =>
      navItem.addEventListener('click', this.navClose.bind(this))
    );
  }

  // メソッド
  onClickDispatcher() {
    if (this.openFlag === false) {
      this.navOpen();
    } else if (this.openFlag === true) {
      this.navClose();
    }
  }

  navOpen() {
    const TL = gsap.timeline();
    TL.add(() => body.classList.add('body-no-scroll'))
      .add(() => humbBtn.classList.add('active'))
      .add(() => humbMenu.classList.add('active'))
      .to('.nav__item', {
        autoAlpha: 1,
        y: 0,
        ease: 'power2.inOut',
        stagger: {
          each: 0.2,
        },
      });
    this.openFlag = true;
  }
  navClose() {
    const TL = gsap.timeline();
    TL.add(() => body.classList.remove('body-no-scroll'))
      .add(() => humbBtn.classList.remove('active'))
      .add(() => humbMenu.classList.remove('active'));
    this.openFlag = false;
  }
}
export default Nav;
